import axios from "axios";
import { getCurrentToken, getCurrentRefreshToken } from "./utility";

export const API = axios.create({ baseURL: process.env.REACT_APP_API_URL });

/**
 * Generate a UUID v4 for idempotency-key header.
 * Uses crypto.randomUUID when available, otherwise a simple fallback.
 * @returns {string} UUID v4 string
 */
export const generateIdempotencyKey = () => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

const getBaseHeaders = () => ({
  "x-access-token": getCurrentToken()?.token,
  "refresh-Token": getCurrentRefreshToken()?.token,
});

export const GET = (url) =>
  API({
    url,
    method: "GET",
    headers: getBaseHeaders(),
    withCredentials: true,
  }).then((response) => response.data);

/**
 * POST request with optional idempotency support.
 * @param {string} url - Request URL
 * @param {object} reqBody - Request body
 * @param {object} [options] - Optional settings
 * @param {boolean} [options.idempotent] - If true, sends idempotency-key header (UUID v4) for duplicate prevention
 */
export const POST = (url, reqBody, options = {}) => {
  const headers = { ...getBaseHeaders() };
  if (options.idempotent) {
    headers["idempotency-key"] = options.idempotencyKey || generateIdempotencyKey();
  }
  return API({
    url,
    method: "POST",
    headers,
    data: reqBody,
    withCredentials: true,
  }).then((response) => response.data);
};

export const UPLOAD = (url, formData) =>
  API({
    url,
    method: "POST",
    headers: {
      ...getBaseHeaders(),
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress: (data) => {
      //console.log("upload progress", data);
    },
    data: formData,
    withCredentials: true,
  }).then((response) => response.data);

export const PUT = (url, reqBody) =>
  API({
    url,
    method: "PUT",
    headers: getBaseHeaders(),
    data: reqBody,
    withCredentials: true,
  }).then((response) => response.data);

export const DELETE = (url) =>
  API({
    url,
    method: "DELETE",
    headers: getBaseHeaders(),
    withCredentials: true,
  }).then((response) => response.data);
